import { ServiceType } from './service-items';

import angularIcon from '@/assets/icons/angular-icon.svg';
import electronIcon from '@/assets/icons/electron-icon.svg';
import flutterIcon from '@/assets/icons/flutter-icon.svg';
import netIcon from '@/assets/icons/net-icon.svg';
import reactIcon from '@/assets/icons/react-icon.svg';
import helzbyLogo from '@/assets/portfolio/helzby/logo.svg';
import helzbyMockup from '@/assets/portfolio/helzby/mockup.jpg';
import helzbyStickerMockup from '@/assets/portfolio/helzby/sticker_mockup.png';
import helzbyThumbnail from '@/assets/portfolio/helzby/thumbnail.jpg';
import iComplyLogo from '@/assets/portfolio/icomply/logo.png';
import iComplyMockup from '@/assets/portfolio/icomply/mockup.png';
import iComplySide from '@/assets/portfolio/icomply/side.png';
import iComplyThumbnail from '@/assets/portfolio/icomply/thumbnail.jpg';
import retailKioskLogo from '@/assets/portfolio/retailKiosk/logo.png';
import retailKioskMockup from '@/assets/portfolio/retailKiosk/mockup.png';
import retailKioskSidePicture from '@/assets/portfolio/retailKiosk/side.png';
import retailKioskThumbnail from '@/assets/portfolio/retailKiosk/thumbnail.jpg';
import stayAheadLogo from '@/assets/portfolio/stayAhead/logo.svg';
import stayAheadMobile from '@/assets/portfolio/stayAhead/mobile.png';
import stayAheadMockup from '@/assets/portfolio/stayAhead/mockup.png';
import stayAheadThumbnail from '@/assets/portfolio/stayAhead/thumbnail.jpg';

interface PortfolioIcon {
  img: string;
  caption: string;
}

export interface PorfolioItem {
  key: string;
  logoSrc: string;
  thumbnailSrc: string;
  mockupSrc: string;
  sidePictureSrc: string;
  title: string;
  categories: ServiceType[];
  introKey: string;
  descriptionKey: string;
  goalsKey: string;
  showInHome: boolean;
  icons: PortfolioIcon[];
}

export const portfolioItems: PorfolioItem[] = [
  {
    key: 'helzby',
    logoSrc: helzbyLogo,
    thumbnailSrc: helzbyThumbnail,
    mockupSrc: helzbyMockup,
    sidePictureSrc: helzbyStickerMockup,
    title: 'Helzby - SaaS Platform',
    categories: [ServiceType.webAppDevelopment, ServiceType.mobileAppDevelopment],
    introKey: 'portfolioItems:helzby:intro',
    descriptionKey: 'portfolioItems:helzby:description',
    goalsKey: 'portfolioItems:helzby:goals',
    showInHome: true,
    icons: [
      { img: reactIcon, caption: 'React Native' },
      { img: netIcon, caption: '.NET Core 3.1' },
      { img: angularIcon, caption: 'Angular' },
    ],
  },
  {
    key: 'stayAhead',
    logoSrc: stayAheadLogo,
    thumbnailSrc: stayAheadThumbnail,
    mockupSrc: stayAheadMockup,
    sidePictureSrc: stayAheadMobile,
    title: 'StayAhead - SaaS Platform',
    categories: [ServiceType.webAppDevelopment, ServiceType.mobileAppDevelopment],
    introKey: 'portfolioItems:stayAhead:intro',
    descriptionKey: 'portfolioItems:stayAhead:description',
    goalsKey: 'portfolioItems:stayAhead:goals',
    showInHome: true,
    icons: [
      { img: flutterIcon, caption: 'Flutter' },
      { img: netIcon, caption: '.NET 8' },
      { img: angularIcon, caption: 'Angular' },
    ],
  },
  {
    key: 'tcfGeneration',
    logoSrc: iComplyLogo,
    thumbnailSrc: iComplyThumbnail,
    mockupSrc: iComplyMockup,
    sidePictureSrc: iComplySide,
    title: 'Technical Compliance File Management System',
    categories: [ServiceType.webAppDevelopment],
    introKey: 'portfolioItems:iComply:intro',
    descriptionKey: 'portfolioItems:iComply:description',
    goalsKey: 'portfolioItems:iComply:goals',
    showInHome: false,
    icons: [
      { img: netIcon, caption: '.NET 8' },
      { img: angularIcon, caption: 'Angular' },
    ],
  },
  {
    key: 'kravetKiosk',
    logoSrc: retailKioskLogo,
    thumbnailSrc: retailKioskThumbnail,
    mockupSrc: retailKioskMockup,
    sidePictureSrc: retailKioskSidePicture,
    title: 'Retail Kiosk Revamp',
    categories: [ServiceType.webAppDevelopment, ServiceType.desktopAppDevelopment],
    introKey: 'portfolioItems:kravetKiosk:intro',
    descriptionKey: 'portfolioItems:kravetKiosk:description',
    goalsKey: 'portfolioItems:kravetKiosk:goals',
    showInHome: true,
    icons: [
      { img: netIcon, caption: '.NET 8' },
      { img: electronIcon, caption: 'Electron' },
      { img: angularIcon, caption: 'Angular' },
    ],
  },
];
